module.exports = __webpack_public_path__ + "static/media/lightsOff.ccf084c3.png";